module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/pre-loaders/custom-loader-2/custom-loader-2.component.scss
// module id = ./src/app/features/pre-loaders/custom-loader-2/custom-loader-2.component.scss
// module chunks = main